<template>
    <div
        :data-component-name="$options.name"
        :class="(!field.inputClass) ? 'o-grid-12' : field.inputClass"
        v-if="!disabledIDs.includes(field.id)"
    >
        <inputlabel :field="field" />

        <div class="o-form__item">
            <div class="o-select__wrap">
                <select class="o-select"
                    :class="{ 'readonly': field.inputReadonly === true }"
                    v-on="readOnlyHandlers"
                    type="text" v-model="field.value"
                    :id="'input-' + field.id"
                    :name="field.inputName"
                    :placeholder="field.inputPlaceholder"
                    :required="(field.inputRequired === true) ? 'required' : false"
                    :multiple="(field.inputChoicesMultiple === true) ? 'multiple' : false"
                    :autocomplete="(field.inputAutocomplete && field.inputAutocomplete != '' && field.inputAutocomplete != 'querystring' && field.inputAutocomplete != 'reactivevalue' && field.inputAutocomplete != 'cookie') ? field.inputAutocomplete : false"
                    @change="emitChange"
                >
                    <option :value="''" disabled selected>{{ (field.inputPlaceholder !== null && field.inputPlaceholder != '') ?
                        field.inputPlaceholder : _t('Choisir') }}</option>
        
                    <option v-for="(choice, ci) in choices" :key="'cb-' + ci + '-' + field.id"
                        :value="(String(choice.value).trim() != '') ? choice.value : choice.text"
                        v-html="(String(choice.text).trim() != '') ? choice.text : choice.value">
                    </option>
                </select>
                <div class="o-form__validation">
                    <span class="o-form__validation__required">
                        {{ _t('Ce champ est obligatoire.') }}
                    </span>
                    <span class="o-form__validation__error">
                        {{ _t('Ce champ est obligatoire.') }}
                    </span>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'Input-nhtsayearselector',
        props: {
            field: {
                type: Object,
                default() {
                    return {}
                },
            },
            disabledIDs: {
                type: Array,
                default() {
                    return []
                },
            },
        },
        data(){
        	return {
                readOnlyHandlers: {
                    keydown: this.handleEvent,
                    paste: this.handleEvent,
                    focus: this.handleEvent,
                    mousedown: this.handleEvent,
                },
                searchByVin: true,
                loading: false,
                isValid: true,
                errorMsg: "",
                emitTO: null,
                eventScope: this.$parent.field.id,
        	}
        },
        mounted(){
            this.$root.getSessionInfo()
            if (this.field.value == null) this.field.value = '';
            if (this.field.repeaterIndex) this.eventScope += '-' + this.field.repeaterIndex;
            this.emitChange();
        },
        computed: {
            choices() {

                let choices = [];

                let min = null;
                if (this.field.inputNumberMin && this.field.inputNumberMin !== null && String(this.field.inputNumberMin).trim() != '') {
                    if (String(this.field.inputNumberMin).trim() != '' && String(this.field.inputNumberMin).startsWith('javascript:')) {
                        try {
                            min = parseInt(eval(this.field.inputNumberMin.replace('javascript:', '')))
                        } catch (e) {
                            console.error(e)
                            min = null
                        }
                    } else {
                        min = parseInt(this.field.inputNumberMin)
                    }
                }
                if (min == null || !Math.round(min)) min = parseInt(new Date().getFullYear() - 1);
                
                let max = null;
                if (this.field.inputNumberMax && this.field.inputNumberMax !== null && String(this.field.inputNumberMax).trim() != '') {
                    if (String(this.field.inputNumberMax).trim() != '' && String(this.field.inputNumberMax).startsWith('javascript:')) {
                        try {
                            max = parseInt(eval(this.field.inputNumberMax.replace('javascript:', '')))
                        } catch (e) {
                            console.error(e)
                            max = null
                        }
                    } else {
                        max = parseInt(this.field.inputNumberMax)
                    }
                }
                if (max==null || !Math.round(max)) max = parseInt(new Date().getFullYear()+1);

                for (let i = Math.min(min, max); i <= Math.max(min, max); i++) {
                    choices.push({
                        value: i,
                        text: String(i)
                    });
                }

                return choices;
            },
        },
        watch: {
            'field.value': function (val) {
                this.emitChange();
            },
        },
        methods: {

            emitChange() {
                clearTimeout(this.emitTO);
                this.emitTO = setTimeout(() => {
                    this.emitter.emit(this.eventScope +':nhtsa-set-year', this.field.value);
                }, 200);
            },

            handleEvent(e) {
                if (this.field.inputReadonly === true && (!e.keyCode || e.keyCode != 9)) e.preventDefault();
            },

        },
    }
</script>